export default "__VITE_ASSET__CACqpf1Z__"